module.exports = __webpack_public_path__ + "static/media/Meld Logo.FINAL-14.d94e8db0.png";